export const locationConstant = {
  CREATE_LOCATION: "CREATE_LOCATION",
  GET_ALL_LOCATIONS: "GET_ALL_LOCATIONS",
  UPDATE_LOCATION: "UPDATE_LOCATION",
  GET_LOCATION: "GET_LOCATION",
  DELETE_LOCATION: "DELETE_LOCATION",
  GET_ALL_ADMIN_LOCATIONS: "GET_ALL_ADMIN_LOCATIONS",
  UPDATE_ADMIN_LOCATION: "UPDATE_ADMIN_LOCATION",
  DELETE_ADMIN_LOCATION: "DELETE_ADMIN_LOCATION",
  GET_MANAGER_SEARCH_LOACTION: "GET_MANAGER_SEARCH_LOACTION",
  GET_MANAGER_ID: "GET_MANAGER_ID",
  IS_LOCATION_EXIST: "IS_LOCATION_EXIST",
  IS_LOADER: "IS_LOADER",
  REMOVE_LOCATIONS: "REMOVE_LOCATIONS",
};
